import React, {useEffect, useState} from "react";
import PropTypes from "prop-types";
import withRouter from "components/Common/withRouter";
import AzureMostFrequentAlertsCardForOptimisation from "../../components/AlertOptimization/AzureAlertOptimization";
import NewRelicMostFrequentAlertsCardForOptimisation from "../../components/AlertOptimization/NewRelicAlertOptimization";
import DatadogMostFrequentAlertsCardForOptimisation from "../../components/AlertOptimization/DatadogAlertOptimization";
import GcpMostFrequentAlertsCardForOptimisation from "../../components/AlertOptimization/GcpAlertOptimization";
import AwsMostFrequentAlertsCardForOptimisation from "../../components/AlertOptimization/AwsAlertOptimization";
import MostFrequentOtherAlertsCard from "../../components/AlertOptimization/OtherAlertsOptimization";

import {Row, Col, Nav, NavItem, NavLink, TabContent, TabPane, Spinner} from "reactstrap";
import classnames from "classnames";

const AlertsForOptimization = () => {

    const [activeTab, setactiveTab] = useState("1");
    const [activeTabIntegrationType, setActiveTabIntegrationType] = useState("CloudWatch");
    const [pageLoading, setPageLoading] = useState(true);

    useEffect(() => {
        setTimeout(
          () => {
              setPageLoading(false);
          },
          500)
    }, [])

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const integrationTypeFromUrl = urlParams.get('integration_type');
        const targetTab = window.location.hash.replace('#', '');

        const tabMapping = {
            'CloudWatch': '1',
            'NewRelic': '2',
            'GCP': '3',
            'Datadog': '4',
            'Azure': '5'
        };

        let activeTabToSet = '1'; // default to AWS
        if (integrationTypeFromUrl) {
            activeTabToSet = tabMapping[integrationTypeFromUrl] || '1';
        } else if (targetTab) {
            activeTabToSet = targetTab;
        }

        setactiveTab(activeTabToSet);
        setActiveTabIntegrationType(
          Object.keys(tabMapping).find(key => tabMapping[key] === activeTabToSet) || 'CloudWatch'
        );
    }, []);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const integrationTypeFromUrl = urlParams.get('integration_type');

        if (integrationTypeFromUrl) {
            // Set active tab based on integration type
            const tabMapping = {
                'CloudWatch': '1',
                'NewRelic': '2',
                'GCP': '3',
                'Datadog': '4',
                'Azure': '5'
            };

            const activeTab = tabMapping[integrationTypeFromUrl];
            if (activeTab) {
                setactiveTab(activeTab);
                setActiveTabIntegrationType(integrationTypeFromUrl);
            }
        }
    }, [window.location.search]);
    const [isLoading, setIsLoading] = useState(false);

    const toggleTab = tab => {
        setIsLoading(true);
        if (activeTab !== tab) {
            setactiveTab(tab);
        }
        let integrationType;
        switch(tab) {
            case "1": integrationType = "CloudWatch"; break;
            case "2": integrationType = "NewRelic"; break;
            case "3": integrationType = "GCP"; break;
            case "4": integrationType = "Datadog"; break;
            case "5": integrationType = "Azure"; break;
        }
        setActiveTabIntegrationType(integrationType);
        const url = new URL(window.location.href);
        url.searchParams.set('integration_type', integrationType);
        window.history.pushState({}, '', url);
        setTimeout(
          () => {
              setIsLoading(false);
          },
          500)
    };
    return (
        <React.Fragment>
            {pageLoading ? (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'15%' }}>
                  <Spinner
                    color="primary"
                    style={{
                        height: '3rem',
                        width: '3rem'
                    }}
                  >
                      Loading...
                  </Spinner>
              </div>
            ):(
              <>
                  <Nav pills className="nav-custom">
                      <NavItem className="nav-item-custom" style={{ width: '20%' }}>
                          <NavLink
                            className={classnames({
                                active: activeTab === "1",
                            })}
                            onClick={() => {
                                toggleTab("1");
                            }}
                          >
                              <span className="d-sm-block">AWS</span>
                          </NavLink>
                      </NavItem>
                      <NavItem className="nav-item-custom" style={{ width: '20%' }}>
                          <NavLink
                            className={classnames({
                                active: activeTab === "2",
                            })}
                            onClick={() => {
                                toggleTab("2");
                            }}
                          >
                              <span className="d-sm-block">NewRelic</span>
                          </NavLink>
                      </NavItem>
                      <NavItem className="nav-item-custom" style={{ width: '20%' }}>
                          <NavLink
                            className={classnames({
                                active: activeTab === "3",
                            })}
                            onClick={() => {
                                toggleTab("3");
                            }}
                          >
                              <span className="d-sm-block">GCP</span>
                          </NavLink>
                      </NavItem>
                      <NavItem className="nav-item-custom" style={{ width: '20%' }}>
                          <NavLink
                            className={classnames({
                                active: activeTab === "4",
                            })}
                            onClick={() => {
                                toggleTab("4");
                            }}
                          >
                              <span className="d-sm-block">Datadog</span>
                          </NavLink>
                      </NavItem>
                      <NavItem className="nav-item-custom" style={{ width: '20%' }}>
                          <NavLink
                            className={classnames({
                                active: activeTab === "5",
                            })}
                            onClick={() => {
                                toggleTab("5");
                            }}
                          >
                              <span className="d-sm-block">Azure</span>
                          </NavLink>
                      </NavItem>
                      {/*<NavItem className="nav-item-custom" style={{ width: '16%' }}>*/}
                      {/*    <NavLink*/}
                      {/*        className={classnames({*/}
                      {/*            active: activeTab === "6",*/}
                      {/*        })}*/}
                      {/*        onClick={() => {*/}
                      {/*            toggleTab("6");*/}
                      {/*        }}*/}
                      {/*    >*/}
                      {/*        <span className="d-sm-block">Other Alerts</span>*/}
                      {/*    </NavLink>*/}
                      {/*</NavItem>*/}
                  </Nav>
                    <hr style={{border: "1px solid #556ee6", backgroundColor: "#556ee6", width: "100%", marginTop: "-1px",}}/>
                  <TabContent activeTab={activeTab} className="py-4">
            <TabPane tabId="1">
                <Row>
                    <Col lg={12}>
                        <AwsMostFrequentAlertsCardForOptimisation
                          title="AWS ALERTS FOR OPTIMIZATION"
                          activeTabIntegrationType={activeTabIntegrationType}
                          loading={isLoading}
                        />
                    </Col>
                </Row>
            </TabPane>
            <TabPane tabId="2">
                <Row>
                    <Col lg={12}>
                        <NewRelicMostFrequentAlertsCardForOptimisation
                          title="NEWRELIC ALERTS FOR OPTIMIZATION"
                          activeTabIntegrationType={activeTabIntegrationType}
                          loading={isLoading}
                        />
                    </Col>
                </Row>
            </TabPane>
            <TabPane tabId="3">
                <Row>
                    <Col lg={12}>
                        <GcpMostFrequentAlertsCardForOptimisation
                          title="GCP ALERTS FOR OPTIMIZATION"
                          activeTabIntegrationType={activeTabIntegrationType}
                          loading={isLoading}
                        />
                    </Col>
                </Row>
            </TabPane>
            <TabPane tabId="4">
                <Row>
                    <Col lg={12}>
                        <DatadogMostFrequentAlertsCardForOptimisation
                          title="DATADOG ALERTS FOR OPTIMIZATION"
                          activeTabIntegrationType={activeTabIntegrationType}
                          loading={isLoading}
                        />
                    </Col>
                </Row>
            </TabPane>
            <TabPane tabId="5">
                <Row>
                    <Col lg={12}>
                        <AzureMostFrequentAlertsCardForOptimisation
                          title="AZURE ALERTS FOR OPTIMIZATION"
                          activeTabIntegrationType={activeTabIntegrationType}
                          loading={isLoading}
                        />
                    </Col>
                </Row>
            </TabPane>
            {/*<TabPane tabId="6">*/}
            {/*    <Row>*/}
            {/*        <Col lg={12}>*/}
            {/*            <MostFrequentOtherAlertsCard*/}
            {/*                title="OTHER ALERTS WHICH HAVE HIGH FREQUENCY OF ALERTS"*/}
            {/*            />*/}
            {/*        </Col>*/}
            {/*    </Row>*/}
            {/*</TabPane>*/}
        </TabContent>
              </>
            )}
        </React.Fragment>
    );
};

AlertsForOptimization.propTypes = {
    props: PropTypes.array,
};

export default withRouter(AlertsForOptimization);
